import { createFrontendModule, ApiBlueprint } from '@backstage/frontend-plugin-api';
import {
  catalogGraphApiRef,
  DefaultCatalogGraphApi,
  ALL_RELATIONS,
  ALL_RELATION_PAIRS,
} from '@backstage/plugin-catalog-graph';

// Custom relations
const CUSTOM_RELATIONS = ['hasManager', 'isManagerOf', 'hasTechnicalContact'];
const CUSTOM_RELATION_PAIRS: [string, string][] = [['hasManager', 'isManagerOf']];

// Combine all known relations and pairs
const ALL_KNOWN_RELATIONS = [...ALL_RELATIONS, ...CUSTOM_RELATIONS];
const ALL_KNOWN_RELATION_PAIRS = [...ALL_RELATION_PAIRS, ...CUSTOM_RELATION_PAIRS];

const catalogGraphApiOverride = ApiBlueprint.make({
  params: (defineParams) =>
    defineParams({
      api: catalogGraphApiRef,
      deps: {},
      factory: () =>
        new DefaultCatalogGraphApi({
          knownRelations: ALL_KNOWN_RELATIONS,
          knownRelationPairs: ALL_KNOWN_RELATION_PAIRS,
          defaultRelationTypes: { exclude: [] },
        }),
    }),
});

export const catalogGraphModule = createFrontendModule({
  pluginId: 'catalog-graph',
  extensions: [catalogGraphApiOverride],
});
